module.exports = __webpack_public_path__ + "static/6-70a3911fb0dab6d0b87a51e39a499a69.png";